import { styled } from "@mui/material/styles";
import { SpaceXxs, AnnouncementBannerColorBlueText, AnnouncementBannerColorBlueBackground, AnnouncementBannerColorDarkGrayText, AnnouncementBannerColorDarkGrayBackground, AnnouncementBannerColorGreenText, AnnouncementBannerColorGreenBackground, AnnouncementBannerColorOrangeText, AnnouncementBannerColorOrangeBackground, AnnouncementBannerColorPurpleText, AnnouncementBannerColorPurpleBackground, AnnouncementBannerColorRedText, AnnouncementBannerColorRedBackground, AnnouncementBannerColorYellowText, AnnouncementBannerColorYellowBackground } from "@nxt-costco-com/forge-design-tokens";
import { Link } from "../../Navigation/Link/index.js";
const StyledLink = styled(Link)`
    display: flex;
    :focus-visible {
        outline: 2px solid Highlight;
        outline: 2px auto -webkit-focus-ring-color;
        outline-offset: ${SpaceXxs};
    }
`;
const BaseBannerStyles = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "auto",
  width: "100%",
  textAlign: "center",
  padding: SpaceXxs
};
const BlueBannerStyles = {
  ...BaseBannerStyles,
  backgroundColor: AnnouncementBannerColorBlueBackground,
  span: {
    color: AnnouncementBannerColorBlueText
  }
};
const DarkGrayBannerStyles = {
  ...BaseBannerStyles,
  backgroundColor: AnnouncementBannerColorDarkGrayBackground,
  span: {
    color: AnnouncementBannerColorDarkGrayText
  }
};
const GreenBannerStyles = {
  ...BaseBannerStyles,
  backgroundColor: AnnouncementBannerColorGreenBackground,
  span: {
    color: AnnouncementBannerColorGreenText
  }
};
const OrangeBannerStyles = {
  ...BaseBannerStyles,
  backgroundColor: AnnouncementBannerColorOrangeBackground,
  span: {
    color: AnnouncementBannerColorOrangeText
  }
};
const PurpleBannerStyles = {
  ...BaseBannerStyles,
  backgroundColor: AnnouncementBannerColorPurpleBackground,
  span: {
    color: AnnouncementBannerColorPurpleText
  }
};
const RedBannerStyles = {
  ...BaseBannerStyles,
  backgroundColor: AnnouncementBannerColorRedBackground,
  span: {
    color: AnnouncementBannerColorRedText
  }
};
const YellowBannerStyles = {
  ...BaseBannerStyles,
  backgroundColor: AnnouncementBannerColorYellowBackground,
  span: {
    color: AnnouncementBannerColorYellowText
  }
};
export {
  BaseBannerStyles,
  BlueBannerStyles,
  DarkGrayBannerStyles,
  GreenBannerStyles,
  OrangeBannerStyles,
  PurpleBannerStyles,
  RedBannerStyles,
  StyledLink,
  YellowBannerStyles
};
